import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import VueElementLoading from 'vue-element-loading';
import Pagination from './../../shared/pagination'

import Vue from "vue";
import JsonExcel from "vue-json-excel";
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
import csvHelper from '../importjsontocsv';
import Loader from './../../shared/loader'

import {
	Validator
} from 'vee-validate'

export default {
	name: 'errorlogreport',
	components: {
		Pagination,
		DatePicker,
		download,
		VueElementLoading,
		Loader,
		JsonExcel,
		BasicSelect
	},

	data: function() {
		return {
			currentPage: 1,
			totalPage: 0,
			totalrows: 0,
			pageLimit: 10,
			copyPayload: false,
			payload: '',
			isLoading: false,
			userid: '',
			errortype: '',
			listWarehouseData: [],
			listClientData: [],
			listErrorLogData: [],
			listErrorTypeNames: [],
			formattedDate: '',
			clientid: '',
			client: '',
			ClientErr: '',
			clientSelected:'',
			toDateFlt: '',
			fromDateFlt: '',
			show: false,
			download: true,
			exceedFlag: false,
			limitExeed: false,
			pageno:'',
			csvFields: [],
			csvFieldsForXls: {},
     csvCheck:'',
		 listErrorLogReportDataforxls:[],
		 reportname: '',
		 resultCount: '',
		 isLoadingforxls: false,
		 clientname:'',
		 warehousename:'',

		}
	},

	created: function() {},

	filters: {
		capitalize: function(value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	},

	mounted() {
		this.calldateFunction()
		this.formattedDate = moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = this.userid = userdetail.userid;
		var loginuserid = userdetail.userid;
		this.userid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('editedjson.errorlogreport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.geterrorlogList()
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				// this.geterrorlogList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				// this.geterrorlogList();
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				// this.getWarehouseList();
				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				// this.geterrorlogList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},

	methods: {
		calldateFunction: function() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromDateFlt = dt;
		},

		onPageChange(page) {
			this.currentPage = page;
			this.geterrorlogList()
			//this.getErrorLogReportData()
		},
		copymodalopen(data) {
			this.payload = data;
			this.copyPayload = true;
		},
		copy(data) {
			var dummy = $('<input>').val(JSON.stringify(data)).appendTo('body').select()
			document.execCommand('copy')
			this.$alertify.success("Payload Copied")
		},

		closecopymodal() {
			this.payload = '';
			this.copyPayload = false;
		},
		dateFormat(date) {
			if (!date) {
				return '';
			} else {
				return moment(date).format('DD-MM-YY HH:mm:ss');
			}
		},
		resetForm() {
			this.listErrorLogData = [];
			this.client='';
			this.fromDateFlt='';
			this.toDateFlt='';
			this.errortype = '';
			this.totalrows = 0;
			this.geterrorlogList();
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		geterrorlogList(obj) {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			//alert('sdsk'+this.client)
			if (obj) {
				this.currentPage = 1;
			}
			var clientListEncrypt = window.localStorage.getItem('clientList');
			var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
			var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
			this.listClientData = JSON.parse(plaintextclient);

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var clientdata = '';
			this.isLoading = true;
			if (this.user_type == 'warehouse_user') {
				if(!this.client){
					for (var i = 1; i < this.listClientData.length; i++) {
						if(i == this.listClientData.length-1){
							clientdata += this.listClientData[i].clientid;
						}else {
							clientdata += this.listClientData[i].clientid+',';
						}
				  }
				}
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getErrorLogReport',
					'data': {
						userid: this.userid,
						errortype: this.errortype,
						clientid:localStorage.getItem("selectedClient"),
						warehouseid:localStorage.getItem("selectedWarehouse"),
						clientdata:clientdata,
					  fromdate: this.dateFormat1(this.fromDateFlt),
						todate: this.dateFormat2(this.toDateFlt),
						limit: this.pageLimit,
						offset: (this.currentPage - 1) * this.pageLimit
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {

					this.listErrorLogData = result.data.data.rows;

					for (var j = 0; j < this.listErrorLogData.length; j++) {
						//console.log('hiii');
					 this.listErrorLogData[j].clientname = null;
					 for (var i = 0; i < this.listClientData.length; i++) {
						 if (this.listErrorLogData[j].clientid == this.listClientData[i].clientid) {
							 console.log(this.listClientData[i].clientname);
							 this.listErrorLogData[j].clientname = this.listClientData[i].clientname
						 }
					 }
				 }
				 for (var j = 0; j < this.listErrorLogData.length; j++) {
					this.listErrorLogData[j].warehousename = null;
					for (var i = 0; i < this.listWarehouseData.length; i++) {
						if (this.listErrorLogData[j].warehouseid == this.listWarehouseData[i].warehouseid) {
							this.listErrorLogData[j].warehousename = this.listWarehouseData[i].warehousename
						}
					}
				}
					this.totalrows = result.data.data.count;
					result.data.errortypes.forEach((el) => {
						if (el.DISTINCT) {
							this.listErrorTypeNames.push(el.DISTINCT)
						}
					})
					if (this.totalrows < this.pageLimit) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalrows / this.pageLimit);
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				});
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);

		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;


		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		getErrorLogReportDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getErrorLogReportData(2);
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			//alert('hii')
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
			  this.getErrorLogReportxslData(3)
			}

		},
		getErrorLogReportData(csvCheck = 0) {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			this.exceedFlag = false;

			this.searchFlag = true;
			this.isLoading = true;



				var errortype = '';
				if (this.errortype != '' || this.errortype != null) {
					errortype = this.errortype
				}
				var clientdata = '';

				if (this.user_type == 'warehouse_user') {
					if(!this.client){
						for (var i = 1; i < this.listClientData.length; i++) {
							if(i == this.listClientData.length-1){
								clientdata += this.listClientData[i].clientid;
							}else {
								clientdata += this.listClientData[i].clientid+',';
							}
					  }
					}
				}


			this.input = ({
				userid: this.userid,
				errortype: errortype,
				clientid:localStorage.getItem("selectedClient"),
				clientdata:clientdata,
				warehouseid : localStorage.getItem("selectedWarehouse"),
				fromdate: this.dateFormat1(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),

			})

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['clientdata','offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getErrorLogReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.count > 0) {
							this.listErrorLogReportDataCsv = [];
							this.show = true;
							this.download = false;
							this.csvFields = {
								'errortype': this.$t('errorLogReport.errorType'),
								'createddate': this.$t('errorLogReport.date'),
								'clientname': this.$t('warehouseClientList.clientName'),
								'warehousename': this.$t('common.warehouse'),
								'filename':  this.$t('errorLogReport.fileName'),
								'apiname':  this.$t('errorLogReport.apiName'),
								'errordescription':this.$t('errorLogReport.description'),
								//'payload':'Payload'
							};
							var dateFilder = [];
							var skipFilter = ['srno','payload','clientid','warehouseid'];
							this.listErrorLogReportDataCsv = result.data.data.rows;
							for (var j = 0; j < this.listErrorLogReportDataCsv.length; j++) {
								//console.log('hiii');
							 this.listErrorLogReportDataCsv[j].clientname = null;
							 for (var i = 0; i < this.listClientData.length; i++) {
								 if (this.listErrorLogReportDataCsv[j].clientid == this.listClientData[i].clientid) {
									 this.listErrorLogReportDataCsv[j].clientname = this.listClientData[i].clientname
								 }
							 }
						 }
						 for (var j = 0; j < this.listErrorLogReportDataCsv.length; j++) {
							this.listErrorLogReportDataCsv[j].warehousename = null;
							for (var i = 0; i < this.listWarehouseData.length; i++) {
								if (this.listErrorLogReportDataCsv[j].warehouseid == this.listWarehouseData[i].warehouseid) {
									this.listErrorLogReportDataCsv[j].warehousename = this.listWarehouseData[i].warehousename
								}
							}
						}

							this.listErrorLogReportDataCsv.forEach(function(entry) {

								if (entry.createddate != '' && entry.createddate != null) {
									entry.createddate = moment(entry.createddate).format('YYYY-MM-DD HH:mm:ss');

								}
							});
							csvHelper.data.jsonToCSV(this.$t('editedjson.errorlogreport'), this.listErrorLogReportDataCsv, this.csvFields, dateFilder, skipFilter,dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getErrorLogReportxslData(csvCheck = 3) {
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.searchFlag = true;
			var clientListEncrypt = window.localStorage.getItem('clientList');
			var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
			var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
			this.listClientData = JSON.parse(plaintextclient);

			this.show = true;
			this.download = false;

			this.dataFilter2 = [];
			var value = '';
			var str = '';
			var clientdata = '';

			var errortype = '';
			if (this.errortype != '' || this.errortype != null) {
				errortype = this.errortype
			}

			if (this.user_type == 'warehouse_user') {
				if(!this.client){
					for (var i = 1; i < this.listClientData.length; i++) {
						if(i == this.listClientData.length-1){
							clientdata += this.listClientData[i].clientid;
						}else {
							clientdata += this.listClientData[i].clientid+',';
						}
					}
				}
			}

			if (csvCheck == 2)
				this.pageno = 0;

				this.input = ({
					userid: this.userid,
					errortype: errortype,
					clientid:localStorage.getItem("selectedClient"),
					clientdata:clientdata,
					warehouseid : localStorage.getItem("selectedWarehouse"),
					fromdate: this.dateFormat1(this.fromDateFlt),
					todate: this.dateFormat2(this.toDateFlt),
     	})

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['clientdata','offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getErrorLogReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.count > 0) {
							this.listErrorLogReportDataforxls = [];

							this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('errorLogReport.errorType')] =	'errortype',
							this.csvFieldsForXls[this.$t('errorLogReport.date')] =	'createddate',
							this.csvFieldsForXls[this.$t('warehouseClientList.clientName')] ='clientname',
							this.csvFieldsForXls[this.$t('common.warehouse')] = 'warehousename',
							this.csvFieldsForXls[this.$t('errorLogReport.fileName')] = 'filename',
							this.csvFieldsForXls[this.$t('errorLogReport.apiName')] = 'apiname',
							this.csvFieldsForXls[this.$t('errorLogReport.description')] = 'errordescription',
								//'Payload':'payload'

							this.listErrorLogReportDataforxls = result.data.data.rows;
							for (var j = 0; j < this.listErrorLogReportDataforxls.length; j++) {
								//console.log('hiii');
							 this.listErrorLogReportDataforxls[j].clientname = null;
							 for (var i = 0; i < this.listClientData.length; i++) {
								 if (this.listErrorLogReportDataforxls[j].clientid == this.listClientData[i].clientid) {
									 this.listErrorLogReportDataforxls[j].clientname = this.listClientData[i].clientname
								 }
							 }
						 }
						 for (var j = 0; j < this.listErrorLogReportDataforxls.length; j++) {
							this.listErrorLogReportDataforxls[j].warehousename = null;
							for (var i = 0; i < this.listWarehouseData.length; i++) {
								if (this.listErrorLogReportDataforxls[j].warehouseid == this.listWarehouseData[i].warehouseid) {
									this.listErrorLogReportDataforxls[j].warehousename = this.listWarehouseData[i].warehousename
								}
							}
						}

							this.listErrorLogReportDataforxls.forEach(function(entry) {
								if (entry.createddate != '' && entry.createddate != null) {
									entry.createddate = moment(entry.createddate).format('YYYY-MM-DD HH:mm:ss');

								}
							});
						} else {
							this.listErrorLogReportDataforxls = [];
							if (result.data.status == true) {
								this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
				}, error => {
					console.error(error);
				})
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/errorlogreport/errorlogreport.component.js